import { ServicesCategoryValues } from '@/components/forms/form-services-category/FormServicesCategory';
import api from '@/services/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

const usePostSports = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const navigate = useNavigate();

  return useMutation({
    mutationKey: ['postSport'],
    mutationFn: ({ data }: { data: ServicesCategoryValues }) => {
      return api.sports.postSports(data);
    },
    onError: (error) => {
      const errorMessage = error.message;
      toast.error(t('toast.error', { errorMessage }));
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sports'] });
      toast.success(t('toast.categoryCreated'));
      navigate(-1);
    },
    retry: false
  });
};

export default usePostSports;
